import t from "./index429.js";
import { createElementBlock as n, openBlock as i, withModifiers as a } from "vue";
import s from "./index231.js";
function p(r, e, c, m, l, f) {
  return i(), n("a", {
    class: "mb-10 mr-20 transition-colors duration-200 text-text-l hover:underline ease-ms",
    "data-component": "MsFooterPrivacyLink",
    href: "javascript:void(0)",
    onClick: e[0] || (e[0] = a((...o) => r.openPrivacyManager && r.openPrivacyManager(...o), ["prevent"]))
  }, " Privatsphäre-Einstellungen ");
}
const k = /* @__PURE__ */ s(t, [["render", p]]);
export {
  k as default
};
